export default __webpack_public_path__ + "static/media/Group1628@2x.7af71cc4.png";